/**
 * Get client-specific asset configuration
 * Returns asset config based on the current client from URL
 */

import { AssetConfig } from '../types/index.js'
import { getClientIdFromURL, getClientConfig, ROQ_CLIENT } from './clients.js'

export function getClientAssetConfig(overrideClientId?: string): AssetConfig {
  const clientId = overrideClientId ?? getClientIdFromURL()

  if (clientId) {
    const clientConfig = getClientConfig(clientId)
    if (clientConfig) {
      const imageTarget = clientConfig.experienceConfig.triggerAssets[0] || '/assets/compiled-image-targets/roq-target.mind'
      // For multi-target collections, default videoUrl is the first character's video (fallback)
      const defaultVideoUrl = clientConfig.characters?.[0]?.videoUrl || '/ROQ x ROCKaBLOCK.MOV'

      return {
        arLibraryUrl: 'https://aframe.io/releases/1.5.0/aframe.min.js',
        mindARLibraryUrl: 'https://cdn.jsdelivr.net/npm/mind-ar@1.2.5/dist/mindar-image-aframe.prod.js',
        imageTargetsUrl: imageTarget,
        roqLogoUrl: clientConfig.experienceItem.thumbnail || '/assets/logos/roq-logo.png',
        videoUrl: defaultVideoUrl,
        // Collection clients (AANA, Pioneers, Freedom Fighters) use video overlays,
        // not GLTF models.  Leave animationModelUrl empty so the preloader skips it
        // and avoids a 404 on the non-existent roq-placeholder.gltf file.
        animationModelUrl: '',
        targetPhysicalWidth: 200,
        preloadTimeout: 15000,
        characters: clientConfig.characters
      }
    }
  }

  // Fallback to ROQ
  return {
    arLibraryUrl: 'https://aframe.io/releases/1.5.0/aframe.min.js',
    mindARLibraryUrl: 'https://cdn.jsdelivr.net/npm/mind-ar@1.2.5/dist/mindar-image-aframe.prod.js',
    imageTargetsUrl: ROQ_CLIENT.experienceConfig.triggerAssets[0] || '/assets/compiled-image-targets/roq-target.mind',
    roqLogoUrl: ROQ_CLIENT.experienceItem.thumbnail || '/assets/logos/roq-logo.png',
    videoUrl: '/ROQ x ROCKaBLOCK.MOV',
    animationModelUrl: '/assets/3d-models/roq-placeholder.gltf',
    targetPhysicalWidth: 200,
    preloadTimeout: 15000
  }
}
